<template>
  <v-app class="admin-organization">
    <Sidebar
      v-if="showSidenav || $vuetify.breakpoint.lgAndUp"
      section="organization"
      :links="links"
    />

    <button
      v-if="$vuetify.breakpoint.mdAndDown"
      class="default-btn blue circle"
      :class="{ open: showSidenav }"
      @click="showSidenav = !showSidenav"
    ><v-icon>mdi-reorder-horizontal</v-icon></button>

    <v-main :class="{
      open: showSidenav || $vuetify.breakpoint.lgAndUp
    }">
      <HelpArea v-if="userRole === 'lender'" />

      <router-view :key="$route.fullPath" />

      <DialogInternalName
        v-if="showInternalNameDialog"
        :newProduct="true"
        @cancel="showInternalNameDialog = false"
        @submit="createNewProduct" />
    </v-main>

    <Footer :class="{
      open: $vuetify.breakpoint.lgAndUp
    }" />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

import Footer from '@/modules/shared/components/ui/Footer'
import Sidebar from '@/modules/shared/components/ui/SideNavbarAdmin'

import HelpArea from './HelpArea'
import DialogInternalName from '../DialogInternalName'

export default {
  name: 'Layout',
  components: {
    Footer,
    Sidebar,

    HelpArea,
    DialogInternalName,
  },

  props: {
    organizationId: String,
  },

  data: () => ({
    products: [],
    showInternalNameDialog: false,
    showSidenav: false,
    links: [
      {
        to: { name: 'OrganizationDashboard' },
        text: 'Dashboard',
      },
      {
        to: { name: 'OrganizationLeads' },
        text: 'Leads',
      },
      {
        text: 'Loan Product Criteria',
        name: 'OrganizationProducts',
        children: [],
      },
      {
        to: { name: 'OrganizationReviews' },
        text: 'Reviews',
      },
    ],
  }),

  computed: {
    ...mapGetters('feathers', ['apiOrganizations', 'apiProducts']),
    ...mapGetters('authStore', ['userRole']),
  },

  created () {
    if (this.$vuetify.breakpoint.lgAndUp) {
      this.showSidenav = true
    }

    this.setOrganizationProductsInNav()
  },

  methods: {
    async setOrganizationProductsInNav () {
      this.products = await this.apiProducts.find({
        query: {
          $select: ['id', 'title', 'internalName', 'published'],
          organizationId: this.organizationId,
        },
      })

      this.links[2].children = [
        ...this.products.map(product => ({
          to: {
            name: 'OrganizationProductsEdit',
            params: { productId: product.id, organizationId: this.organizationId },
          },
          text: `${product.internalName || product.title}`,
          draft: !product.published,
          indicator: product.published ? 'green' : 'yellow',
        })),
        {
          click: () => {
            this.showInternalNameDialog = true
          },
          text: 'Add Loan Product',
          inset: true,
        },
      ]
    },

    async createNewProduct (name) {
      try {
        const organization = await this.apiOrganizations.get(this.organizationId, {
          query: {
            $select: ['name'],
          },
        })

        const product = await this.apiProducts.create({
          organizationId: this.organizationId,
          title: organization.name,
          internalName: name,
          published: false,
        })

        this.$router.push({
          name: 'OrganizationProducts',
          params: { productId: product.id, organizationId: this.organizationId },
        })

        this.showInternalNameDialog = false
      } catch (error) {
        this.addErrorAlert(`Could not create the product: ${error.message}`)
      }
    },
  },
}
</script>

<style lang="scss">
.v-application.admin-organization {
  font-family: "Sansation Regular", sans-serif;
  @import "../../../shared/assets/styles/admin.scss";
}
</style>

<style lang="scss" scoped>
.v-application {
  .default-btn.circle {
    position: fixed;
    top: 15px;
    left: 15px;
    z-index: 10;

    height: 40px;
    width: 40px;
    padding: 0;

    opacity: 0.6;

    &.open {
      left: 280px;
    }

    .v-icon {
      font-size: 24px;
    }
  }
}
</style>
